<!--
    校区管理-校区列表-年服务设置
    作用：配置校区年服务时间
    组件：el-dialog
-->
<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="年服务设置"
      width="650px"
    >
      <div class="content">
        <div class="mian-title">
          <span class="item">校区名称：{{ item.review_used.name }}</span>
          <span class="item">校区代码：{{ item.school_code }}</span>
        </div>
        <el-form>
          <el-form-item label="年服务时间：">
            <el-date-picker
              :default-time="['00:00:00', '23:59:59']"
              v-model="dateVal"
              :picker-options="pickerOptions"
              size="small"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"/>
          </el-form-item>
        </el-form>
        <div class="tip">备注：默认最近一年时间，开始时间不低于校区注册时间+3天</div>
      </div>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          class="mr-10"
          @click="handleClose">取消</el-button>
        <el-button
          :loading="loading"
          type="primary"
          @click="submitData()">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'SetAnnualFee',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    pickerOptions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      dateVal: null,
    };
  },
  mounted() {
    if (this.item.vip_end_at && this.item.vip_start_at) {
      this.dateVal = [this.item.vip_start_at, this.item.vip_end_at];
    } else {
      const createdTime = (new Date(this.item.created_at)).getTime() + (2 * 24 * 60 * 60 * 1000);
      const timestamp = new Date().getTime();
      if (createdTime < timestamp) {
        const t1 = moment().format('YYYY-MM-DD');
        const t2 = moment().add(1, 'year').format('YYYY-MM-DD');
        this.dateVal = [`${t1} 00:00:00`, `${t2} 23:59:59`];
      } else {
        const a = moment(this.item.created_at).add(3, 'day');
        const t1 = moment(a).format('YYYY-MM-DD');
        const t2 = moment(a).add(1, 'year').format('YYYY-MM-DD');
        this.dateVal = [`${t1} 00:00:00`, `${t2} 23:59:59`];
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close-dialog');
    },
    submitData() {
      if (this.dateVal) {
        const starTime = this.dateVal[0];
        const endTime = this.dateVal[1];
        this.$http.patch(`/api/service/operate/clients/${this.item.id}/vip`, {
          vip_start_at: starTime,
          vip_end_at: endTime,
          vip_type: 2,
        }).then(() => {
          this.$emit('close-dialog');
          this.$emit('refresh-data');
          this.$message.success('年服务设置成功！');
        }).catch((err) => {
          this.$message.error(err.message);
        });
      } else {
        this.$message.warning('请选择年服务时间！');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mian-title{
  padding-bottom: 30px;
  .item{
    display: inline-block;
    margin-right: 15px;
  }
}
.tip{
  color: #FAAD14;
}
</style>



// WEBPACK FOOTER //
// src/views/CampusManagement/list/dialog/setAnnualFee.vue